import React, { Component } from 'react';
import { getConsent,postConsent } from '../api';

export default class UserConsentNotAccepted extends Component {
    constructor(props){
        super(props)
        this.state = {
            consent: null
        }
    }

    componentDidMount(){
        this.loadConsent()
    }

    loadConsent(){
        getConsent((err,res) => {
            if (err) console.log(err);
            
            if(res) {
                const consentData = Object.values(res.data)[0][1].terminos_y_condiciones
                this.setState({ consent: consentData });
            }
        })
    }

    acceptConsent(){
        postConsent((err,res)=>{
            if(err){
                console.log(err)
            }else{
                this.props.consentModal(false)
                this.props.acceptConsentModal(true)
            }
        })
    }

    render(){
        return(
   
            (this.state.consent && <div className="consent-container">
                <div className="consent-modal">
                    <div className='consent-title__container'>
                        <h2 className="consent-title">CONSENTIMIENTO</h2>
                    </div>
                    <div className='consent-content__container'>
                        <p>{this.state.consent}</p>
                        <div className='consent-button__container'>
                            <button className='consent-button' onClick={()=>{
                                this.acceptConsent()
                            }}>ACEPTAR</button>
                            <button className='consent-button' onClick={()=>{
                                this.props.doLogout()
                                this.props.consentModal(false)
                            }} >RECHAZAR</button>
                        </div>
                    </div>
                </div>
            </div>)
        )  
    }
}